import BaseRepository from '@/repository/BaseRepository'
import { getLocalTimeZone, today } from '@internationalized/date'

type SimpleDate = {
  year: number
  month: number
  day: number
}

type DateRange = {
  start: SimpleDate
  end: SimpleDate
}

const STORAGE_KEYS = {
  DATE_RANGE: 'date_range',
  AGENCES_IDS: 'agences_ids',
} as const

const currentYear = today(getLocalTimeZone()).year
const DEFAULT_DATE_RANGE: DateRange = {
  start: { year: currentYear, month: 1, day: 1 },
  end: { year: currentYear, month: 12, day: 31 },
}

export function getStoredDate(): DateRange {
  const savedDate = localStorage.getItem(STORAGE_KEYS.DATE_RANGE)
  return savedDate ? JSON.parse(savedDate) : DEFAULT_DATE_RANGE
}

export function getStoredStartDate(): string {
  const date = getStoredDate().start
  return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`
}

export function getStoredEndDate(): string {
  const date = getStoredDate().end
  return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`
}

export async function getAgencesID(): Promise<number[]> {
  const agences = localStorage.getItem(STORAGE_KEYS.AGENCES_IDS)
  if (agences) {
    try {
      return JSON.parse(agences)
    } catch {
      // Si le JSON est invalide, on réinitialise
      localStorage.removeItem(STORAGE_KEYS.AGENCES_IDS)
    }
  }

  const data = await BaseRepository.getAgences()
  const agences_ids = data?.map((option) => option.id) ?? []
  localStorage.setItem(STORAGE_KEYS.AGENCES_IDS, JSON.stringify(agences_ids))
  return agences_ids
}
